import { z } from 'zod'
import { FirestoreTimestamp } from './utils'

/**
 * CompanyUserInvitation - Pending invitations for company users
 *
 * Collection path: companyUserInvitations/{invitationId}
 */
export const CompanyUserInvitation = z.object({
  invitationId: z.string(),
  companyId: z.string(),
  companyName: z.string(),

  // User details
  userId: z.string(), // User already created, waiting for password setup
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  role: z.enum(['mechanic', 'inspector', 'admin']),

  // Status tracking
  status: z.enum(['pending', 'accepted', 'expired', 'cancelled']),
  token: z.string(), // Secure random token for acceptance

  // Audit
  invitedBy: z.string(), // Admin userId
  invitedAt: FirestoreTimestamp,
  expiresAt: FirestoreTimestamp, // 7 days default
  acceptedAt: FirestoreTimestamp.optional(),
})

export type CompanyUserInvitation = z.infer<typeof CompanyUserInvitation>
